import { render } from "./NetworkIndicator.vue?vue&type=template&id=4089de56"
import script from "./NetworkIndicator.vue?vue&type=script&lang=js"
export * from "./NetworkIndicator.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__